import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Helper } from 'src/app/shared/utils/helper';

@Injectable({
  providedIn: 'root'
})
export class CompanyService {

  private baseUrl = environment.baseUrl;

  constructor(private http: HttpClient) { }

  listCompany(filter) {
    const {Page, Query, Sort,SortDirection, filterDate } = filter;
    let prm: HttpParams = new HttpParams()
      .set('Page', Page)
      .set('Query', Query);
      if (Sort!=null&&SortDirection!=null) {
        prm = prm.set('Sort', Sort).set('SortDirection', SortDirection);
      }
      // if (filterDate!=null) {
      //   const fd = Helper.getDateStr(filterDate[0])
      //   const td = Helper.getDateStr(filterDate[1])
      //   prm = prm.set('dateFrom', fd).set('dateTo', td);
      // }
    return this.http.get(`${this.baseUrl}/business/list`, { params: prm });
  }

  getBusiness(businessId){
    return this.http.get(`${this,this.baseUrl}/business/view/${businessId}`)
  }

  getBusinessDetails(businessId){
    return this.http.get(`${this,this.baseUrl}/business/view/full/${businessId}`)
  }

  getConsignmentState(filter){
    const {Sort,SortDirection, filterDate, BusinessId } = filter;
    let prm: HttpParams = new HttpParams().set("OnlyOwn",false+"")
      if (Sort!=null&&SortDirection!=null) {
        prm = prm.set('Sort', Sort).set('SortDirection', SortDirection);
      }
      if (BusinessId!=null) {
        prm = prm.set('BusinessId', BusinessId);
      }
      if (filterDate!=null) {
        const fd = Helper.getDateStr(filterDate[0])
        const td = Helper.getDateStr(filterDate[1])
        prm = prm.set('dateFrom', fd).set('dateTo', td);
      }
    return this.http.get(`${this,this.baseUrl}/consignment/list/stats/`,{params:prm})
  }

  getUserList(filter){
    const {Page, Query, Sort, SortDirection, businessId, Status} = filter;
    let params = new HttpParams().set("Page",Page).set("Query", Query)
    .set("BusinessId", businessId)
    .set("UserStatus",Status).set("UserType","Customer");
    if (Sort!=null&&SortDirection!=null) {
      params = params.set("Sort",Sort).set("SortDirection",SortDirection)
    }
    return this.http.get(`${this.baseUrl}/user/list`, {params:params});
  }
  getInvitUserList(filter){
    const {Page, Query, Sort, SortDirection, businessId, Status} = filter;
    let params = new HttpParams().set("Page",Page).set("Query", Query)
    .set("BusinessId", businessId)
    .set("UserStatus",Status)
    .set("OnlyOwn","true")
    .set("UserType","Customer");
    if (Sort!=null&&SortDirection!=null) {
      params = params.set("Sort",Sort).set("SortDirection",SortDirection)
    }
    let userApi = "user/invite/list";
    if (Status=="Suspended"||Status=="Active") {
      userApi = "user/list";
    }
    console.log(Status, userApi);

    return this.http.get(`${this.baseUrl}/${userApi}`, {params:params});
  }

  inviteUser(data){
    return this.http.post(`${this.baseUrl}/user/invite`, data);
  }
  updateUser(data){
    return this.http.put(`${this.baseUrl}/user/edit`, data);
  }
  getUser(id){
    return this.http.get(`${this.baseUrl}/user/view/${id}`);
  }
  onDelete(id){
    return this.http.delete(`${this.baseUrl}/user/delete/${id}`);
  }

  /** OLD Code */
  createCompany(o) {
    return this.http.post(`${this.baseUrl}/api/company/create`, o);
  }

  listCompany__(admin: boolean = false) {
    if (admin === true) {
      let prm = new HttpParams().set('admin', '1');
      return this.http.get(`${this.baseUrl}/api/company/list`, { params: prm });
    }

    return this.http.get(`${this.baseUrl}/api/company/list`);
  }

  getCompany(id) {
    let prm: HttpParams = new HttpParams()
      .set('id', id);
    return this.http.get(`${this.baseUrl}/api/company/details`, { params: prm });
  }

  getCompanyDetails() {
    return this.http.get(`${this.baseUrl}/api/company/details`);
  }

  addCompanyService(o) {
    return this.http.post(`${this.baseUrl}/api/company/add_service`, o);
  }

  updateCompany(o) {
    return this.http.put(`${this.baseUrl}/api/company/update`, o);
  }

  listUser(page, limit, sort, dir, company_id, pending: boolean = false, active = false, value = '') {
    let i = Helper.getStart(page, limit);
    if (pending === true) {
      let prm = new HttpParams()
        .set('start', `${i}`)
        .set('length', limit)
        .set('order', sort)
        .set('dir', dir)
        .set('pending', '1')
        .set('company_id', company_id)
        .set('value', value);
      return this.http.get(`${this.baseUrl}/api/company/user/list`, { params: prm });
    }

    if (active === true) {
      let prm = new HttpParams()
        .set('start', `${i}`)
        .set('length', limit)
        .set('order', sort)
        .set('dir', dir)
        .set('active', '1')
        .set('company_id', company_id)
        .set('value', value);
      return this.http.get(`${this.baseUrl}/api/company/user/list`, { params: prm });
    }

    let prm = new HttpParams()
      .set('start', `${i}`)
      .set('length', limit)
      .set('order', sort)
      .set('dir', dir)
      .set('active', '0')
      .set('company_id', company_id)
      .set('value', value);
    return this.http.get(`${this.baseUrl}/api/company/user/list`, { params: prm });
  }

  assignUser(o) {
    return this.http.post(`${this.baseUrl}/api/company/user/new`, o);
  }
}
